// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"9e50b959","513":"1e6f0e5b","703":"7c35e952","787":"3007c8d5"}[chunkId] + ".chunk.js";
};